import apiClient from "./axios"

// ✅ Get accessories lists (with filters / pagination)
export const getAccessoriesLists = async (params = {}) => {
  const { data } = await apiClient.get("/accessories-lists", { params })
  return data
}

// ✅ Get single accessories list by ID
export const getAccessoriesList = async id => {
  const { data } = await apiClient.get(`/accessories-lists/${id}`)
  return data
}

// ✅ Create accessories list
export const createAccessoriesList = async payload => {
  const { data } = await apiClient.post("/accessories-lists", payload)
  return data
}

// ✅ Update accessories list
export const updateAccessoriesList = async ({ id, ...payload }) => {
  const { data } = await apiClient.patch(
    `/accessories-lists/${id}`,
    payload
  )
  return data
}

// ✅ Soft delete (move to trash)
export const deleteAccessoriesList = async id => {
  const { data } = await apiClient.delete(`/accessories-lists/${id}`)
  return data
}

// ✅ Get all accessories lists (no pagination)
export const getAllAccessoriesLists = async (params = {}) => {
  const { data } = await apiClient.get("/accessories-lists", {
    params: { ...params, all: true },
  })
  return data
}

// ✅ Search accessories lists
export const searchAccessoriesLists = async (searchTerm, params = {}) => {
  const { data } = await apiClient.get("/accessories-lists", {
    params: { ...params, search: searchTerm },
  })
  return data
}

// ✅ Get trashed accessories lists
export const getTrashedAccessoriesLists = async (params = {}) => {
  const { data } = await apiClient.get(
    "/accessories-lists/trashed",
    { params }
  )
  return data
}

// ✅ Get accessories list by slug
export const getAccessoriesListBySlug = async slug => {
  const { data } = await apiClient.get(
    `/accessories-lists/slug/${slug}`
  )
  return data
}

// ✅ Restore trashed accessories list
export const restoreAccessoriesList = async id => {
  const { data } = await apiClient.post(
    `/accessories-lists/${id}/restore`
  )
  return data
}

// ✅ Permanently delete accessories list
export const forceDeleteAccessoriesList = async id => {
  const { data } = await apiClient.delete(
    `/accessories-lists/${id}/force-delete`
  )
  return data
}
